import { render, staticRenderFns } from "./ServiceTypeCard.vue?vue&type=template&id=402e4b67&scoped=true&class=justify-center"
import script from "./ServiceTypeCard.vue?vue&type=script&lang=js"
export * from "./ServiceTypeCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeCard.vue?vue&type=style&index=0&id=402e4b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e4b67",
  null
  
)

export default component.exports